import React, { Component } from 'react';
import Loading from '@/page/components/loading/loading';
import confirm from '@/page/components/confirm';
import DocumentTitle from 'react-document-title';
import API from '@/api/api';
import queryString from 'query-string';
import zhCN from 'antd/es/locale/zh_CN';
import { message, Table, Button, Input, ConfigProvider } from 'antd';
import './index.less';

const columns = [
    {
        title: '歌曲',
        dataIndex: 'musicName',
        key: 'musicName',
    },
    {
        title: '歌手',
        dataIndex: 'singer',
        key: 'singer',
    },
    {
        title: '专辑',
        dataIndex: 'album',
        key: 'album',
    }
];
let circleId;
export default class extends Component {
    state = {
        musicList: [],
        keyword: '',
        isLoading: true,
        pagination: {
            hideOnSinglePage: true,
            showQuickJumper: false,
            showSizeChanger: false,
            pageSize: 10,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`
        }
    }

    operateColumn = {
        title: '操作',
        render: (text, record, index) => {
            return <Button type='primary' onClick={() => this.deleteMusic(record)}>删除</Button>
        }
    }

    componentDidMount() {
        const parsed = queryString.parse(window.location.search);
        circleId = parsed.circleId || this.props.location.state.circleId;
        this.fetchData();
    }

    fetchData = async () => {
        const { keyword, pagination } = this.state;
        const result = await API.musicList({
            keyword, circleId,
            pageNo: pagination.current, pageSize: pagination.pageSize
        });
        if (!result) return;
        if (result.status === '1') {
            const { datas: musicList, totalNum } = result.data;
            pagination.total = Number(totalNum);
            this.setState({ isLoading: false, musicList, pagination });
        } else {
            message.error(result.msg);
        }
    }

    deleteMusic = async record => {
        if (await confirm('确定删除吗')) {
            await API.musicDelete({ musicId: record.musicId, circleId });
            message.info('删除成功');
            this.fetchData();
        }
    }

    onKeywordChange = t => {
        this.setState({ keyword: t.target.value });
    }

    handleTableChange = pn => {
        let { pagination } = this.state;

        pagination.current = pn.current;
        this.setState({
            pagination
        }, () => {
            this.fetchData();
        });
    };

    doSearch = () => {
        let { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination
        }, () => {
            this.fetchData();
        });
    }

    reset = () => {
        let { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            keyword: '', pagination
        }, () => {
            this.fetchData();
        });
    }

    addMusic = () => {
        this.props.history.push(`/music/manage/add?circleId=${circleId}`);
    }

    render() {
        const {
            isLoading,
            keyword,
            musicList,
            pagination
        } = this.state;
        if (isLoading) return <Loading />;
        return (
            <DocumentTitle title='管理音乐'>
                <ConfigProvider locale={zhCN}>
                    <main className='page_manage'>
                        <div className="title">管理音乐</div>
                        <div className='search_box mt10'>
                            <Input style={{ width: '240px' }} value={keyword}
                                onChange={this.onKeywordChange} onPressEnter={this.doSearch}
                                placeholder="歌曲\歌手\专辑"></Input>
                            <Button className='ml10' onClick={this.doSearch}>搜索</Button>
                            <Button className='ml10' onClick={this.reset}>重置</Button>
                        </div>
                        <Button className='mt10' onClick={this.addMusic}>添加歌曲</Button>
                        <Table
                            className="mt10"
                            bordered={true}
                            columns={[...columns, this.operateColumn]}
                            dataSource={musicList}
                            pagination={pagination}
                            // scroll={{ x: true, scrollToFirstRowOnChange: true }}
                            onChange={this.handleTableChange}
                            rowKey={(row) => row.musicId}
                        />
                    </main>
                </ConfigProvider>
            </DocumentTitle>
        );
    }
}